import React, { Fragment, useEffect, useState } from 'react'
import { formatDbDate } from '../../utils/dateFormater';
import { useSelector } from 'react-redux';
import Loader from '../loader/loader';
import DefaultAvatar from "../images/default_avatar.jpg"
import { formatWhatsAppNumber } from '../../utils/whatsappLinkFormater';
import { getCountdown } from '../../utils/Countdown';
import { Link, useSearchParams } from 'react-router-dom';
const SingleReservation = ({ reservation, index, totalReservations, user, setShowPopup, page, selectedReservations, setSelectedReservations }) => {

    const [copied, setCopied] = useState(false);
    const [IsExpired, setIsExpired] = useState(null);

    const [searchParams] = useSearchParams();
    const perPage = searchParams.get("perPage");

    const { loading } = useSelector(state => state.inviteUser)


    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };





    const displayIndex = String(
        totalReservations - ((page - 1) * Number(perPage) + index)
    ).padStart(2, '0');
    




    const handleReserve = (reservationId) => {


        setSelectedReservations([reservationId]);
        setShowPopup(true);


    }


    const [timeLeft, setTimeLeft] = useState(
        getCountdown(reservation?.expires_at)
    );

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown(reservation?.expires_at));

            const now = new Date().getTime();
            const expiry = new Date(reservation?.expires_at).getTime();

            if (now >= expiry) {
                setIsExpired(true);
            } else {
                setIsExpired(false)
            }


        }, 1000);

        return () => clearInterval(interval);
    }, [reservation?.expires_at]);





    return (
        <Fragment>
            {(loading || IsExpired === null) && <Loader />}
            <div 
                className="grid py-[1vmax] items-center border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors"
                style={{ gridTemplateColumns: user?.role !== 'PM' 
                    ? 'minmax(0, 0.7fr) minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(0, 1.8fr) minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 2.5fr)' 
                    : 'minmax(0, 0.7fr) minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.8fr) minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 2.5fr)' }}
            >
                {/* Select */}
                <div className="flex-center" >
                    <input
                        type="checkbox"
                        className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                        checked={selectedReservations?.includes(reservation.id)}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setSelectedReservations(prev => [...prev, reservation.id]);
                            } else {
                                setSelectedReservations(prev => prev.filter(id => id !== reservation.id));
                            }
                        }}
                    />
                </div>

                {/* No. */}
                <div className="text-center text-gray-400 font-medium text-[1.8vmax] lg:text-[0.9vmax]" >
                    {displayIndex}
                </div>

                {/* Product Image */}
                <div className="flex-center">
                    <div className="w-[8vmax] aspect-square flex-center overflow-hidden rounded-lg shadow-sm border border-gray-100 bg-white" >
                        <img src={reservation?.custom_image || DefaultAvatar} alt="" className="w-full h-full object-cover" />
                    </div>
                </div>

                {/* Seller */}
                <div className="flex-center flex-col text-[#4c4c5c] text-[1.8vmax] lg:text-[0.9vmax]" >
                    <a href={formatWhatsAppNumber(reservation?.seller_country_code, reservation?.seller_phone_number)} target="_blank" rel="noopener noreferrer" className="mb-[0.5vmax]">
                        <i className="fa-brands fa-whatsapp text-green-600 text-[2.5vmax]"></i>
                    </a>
                    <div className="text-center font-semibold text-gray-700">
                        {reservation?.seller_pmm_id ? String(reservation.seller_pmm_id).padStart(2, '0') : "N/A"}
                    </div>
                </div>

                {/* Market */}
                <div className="text-center text-indigo-600 font-bold text-[1.8vmax] lg:text-[0.9vmax] uppercase" >
                    {reservation?.market || "N/A"}
                </div>

                {/* Product ID */}
                <div className="text-center text-gray-700 font-semibold text-[1.8vmax] lg:text-[0.9vmax] flex gap-2 items-center justify-center" >
                    <span>{reservation.product_id}</span>
                    <button
                        onClick={() => handleCopy(reservation.product_id)}
                        className="text-gray-400 hover:text-indigo-600 transition-colors"
                        title={copied ? "Copied" : "Copy"}
                    >
                        <i className={`fa-regular ${copied ? "fa-circle-check text-green-600" : "fa-copy"} text-[1.5vmax] lg:text-[1vmax]`}></i>
                    </button>
                </div>

                {/* Reserved By (PM) */}
                {(user?.role !== "PM") &&
                    <div className="flex-center flex-col text-[#4c4c5c] text-[1.8vmax] lg:text-[0.9vmax]" >
                        <a href={formatWhatsAppNumber(reservation?.pm_country_code, reservation?.pm_phone_number)} target="_blank" rel="noopener noreferrer" className="mb-[0.5vmax]">
                            <i className="fa-brands fa-whatsapp text-green-600 text-[2.5vmax]"></i>
                        </a>
                        <div className="text-center font-semibold text-gray-700">{reservation.pm_name}</div>
                    </div>
                }

                {/* Reserved On */}
                <div className="text-center text-gray-500 font-medium text-[1.8vmax] lg:text-[1vmax]" >
                    {formatDbDate(reservation?.created_at)}
                </div>

                {/* Expires In */}
                <div className="text-center text-rose-500 font-bold text-[1.8vmax] lg:text-[1.1vmax] tabular-nums" >
                    {reservation?.status === "ACTIVE" ? timeLeft : '--'}
                </div>

                {/* Status */}
                <div className="flex-center" >
                    <span className={`text-center text-[1.8vmax] lg:text-[0.85vmax] font-bold uppercase p-[0.3vmax_1vmax] rounded-lg shadow-sm
                        ${reservation?.status === "COMPLETED" ? "bg-blue-50 text-blue-500 border border-blue-100" : (reservation?.status === "CANCELLED" || reservation?.status === "SUSPENDED") ? "bg-orange-50 text-orange-400 border border-orange-100" : (IsExpired || reservation?.status === "SYSTEM_CANCELLED") ? "bg-red-50 text-red-500 border border-red-100" : "bg-green-50 text-green-500 border border-green-100"
                        }
                        `}
                    >
                        {
                            reservation?.status === "COMPLETED" ? "Completed"
                                :
                                reservation?.status === "CANCELLED" ? "Cancelled"
                                    :
                                    reservation?.status === "SYSTEM_CANCELLED" ? "System Cancel"
                                        :
                                        reservation?.status === "SUSPENDED" ? "Suspended"
                                            :
                                            IsExpired ? "Expired" : reservation?.status
                        }
                    </span>
                </div>

                {/* Action */}
                <div className="flex-center gap-[1vmax]" >
                    {user?.role === 'PM' &&
                        <Link
                            to={`/orders/create-order?reservation_id=${reservation?.id}`}
                            onClick={(e) => {
                                if (IsExpired || reservation?.status === "COMPLETED" || reservation?.status === "CANCELLED") {
                                    e.preventDefault();
                                }
                            }}
                            className={`px-4 py-2 flex-center bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-all text-white text-[1.6vmax] lg:text-sm font-semibold shadow-sm whitespace-nowrap
                            ${(IsExpired || reservation?.status !== "ACTIVE")
                                    ? "opacity-50 cursor-not-allowed pointer-events-none"
                                    : ""}`}
                            disabled={IsExpired || reservation?.status !== "ACTIVE"}
                        >
                            Create Order
                        </Link>
                    }
 
                    <button className={`px-4 py-2 flex-center bg-white border border-rose-200 text-rose-500 rounded-lg hover:bg-rose-50 transition-all text-[1.6vmax] lg:text-sm font-semibold shadow-sm whitespace-nowrap dark:bg-transparent dark:border-rose-800 dark:text-rose-400 dark:hover:bg-rose-900/20
                        ${(IsExpired || reservation?.status !== "ACTIVE") ? "opacity-50 cursor-not-allowed" : ""}`}
                        onClick={() => handleReserve(reservation.id)}
                        disabled={IsExpired || reservation?.status !== "ACTIVE"}
                    >
                        Release
                    </button>
                </div>
            </div>


        </Fragment>
    )
}

export default SingleReservation